<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.customer') }}
            <template v-if="ready">
              >
              {{ customer.customer_name }}
            </template>
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="customer !== null"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.customer')+' / '+$t('message.partner')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.storecompanyperson') }} *</label>
                    <input
                      ref="name"
                      :class="[bindClass.name]"
                      v-model="form.name"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control"
                      @keyup="onKeyupName">
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.gender') }}</label>
                    <select
                      v-model="form.gender"
                      :disabled="disabledForm"
                      class="custom-select form-control">
                      <option value="">{{ $t('placeholder.select') }}</option>
                      <option value="m">{{ $t('message.male') }}</option>
                      <option value="f">{{ $t('message.female') }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.birthdate') }}</label>
                    <BaseInputDatePicker
                      v-model="form.birthdate"
                      :disabled="disabledForm"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.address"
                      :disabled="disabledForm"
                      class="form-control"
                      style="min-height: 70px"/>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.taxpayerno') }}</label>
                    <input
                      v-model="form.tax_id"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.contactsandnote')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      ref=""
                      v-model="form.tel"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      ref=""
                      v-model="form.email"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div
                v-if="originalForm.line"
                class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.lineid') }}</label>
                    <input
                      ref=""
                      v-model="form.line"
                      :disabled="true"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.note') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.note"
                      :disabled="disabledForm"
                      class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="!disabledForm"
          class="action-bar"
        >
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="update()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'ContactCustomerEdit',
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      form: {
        name: '',
        gender: '',
        birthdate: null,
        address: '',
        tax_id: '',
        email: '',
        tel: '',
        line: '',
        note: '',
      },

      originalForm: null,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null, // Only for `v-date-picker`
        dayPopover: null, // Only for `v-date-picker`
      },
      bindClass: {
        name: null,
      },

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      dateformat: 'getDateFormat',
      customer: 'getCustomer',
      getPartnerContact: 'getPartnerContact',
      getPartnerContactIdByPlatform: 'getPartnerContactIdByPlatform',
    }),
    isValidForm () {
      if (this.form.name.trim().length == 0) {
        this.bindClass.name = 'is-invalid'
        return false
      } else {
        this.bindClass.name = null
        return true
      }
    },
    dataSetUpdate () {
      let dataSet = {}
      let customer = this.customer
      let form = this.form

      if (!customer) {
        return null
      }

      let customerContact = this.getPartnerContact(customer.contacts)

      form.address = form.address == null ? '' : form.address
      form.gender = form.gender == null ? '' : form.gender
      form.note = form.note == null ? '' : form.note

      dataSet['customer_id'] = customer.customer_id
      dataSet['name'] = !form.name ? null : form.name.trim()
      dataSet['address'] = !form.address ? null : form.address.trim()
      dataSet['tax_id'] = !form.tax_id ? null : form.tax_id.trim()
      dataSet['gender'] = !form.gender ? null : form.gender.trim()
      dataSet['birthdate'] = !form.birthdate ? null : form.birthdate.toISOString()
      dataSet['note'] = !form.note ? null : form.note.trim()
      dataSet['contacts'] = {
        'insert': [],
        'update': [],
        'delete': [],
      }

      if (customerContact.email == null) {
        if (form.email !== customerContact.email) {
          if (form.email.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'email',
              'source': form.email,
            })
          }
        }
      } else {
        if (form.email !== customerContact.email) {
          if (form.email.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getPartnerContactIdByPlatform('email', customer.contacts),
              'platform': 'email',
              'source': form.email,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getPartnerContactIdByPlatform('email', customer.contacts),
            })
          }
        }
      }

      if (customerContact.tel == null) {
        if (form.tel !== customerContact.tel) {
          if (form.tel.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'tel',
              'source': form.tel,
            })
          }
        }
      } else {
        if (form.tel !== customerContact.tel) {
          if (form.tel.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getPartnerContactIdByPlatform('tel', customer.contacts),
              'platform': 'tel',
              'source': form.tel,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getPartnerContactIdByPlatform('tel', customer.contacts),
            })
          }
        }
      }

      if (customerContact.line == null) {
        if (form.line !== customerContact.line) {
          if (form.line.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'line',
              'source': form.line,
            })
          }
        }
      } else {
        if (form.line !== customerContact.line) {
          if (form.line.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getPartnerContactIdByPlatform('line', customer.contacts),
              'platform': 'line',
              'source': form.line,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getPartnerContactIdByPlatform('line', customer.contacts),
            })
          }
        }
      }

      return dataSet
    },
    disabledForm () {
      return !this.hasRoleEdit
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
      // dataTable option
      let option = this.dataTableOption()
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.cus_id) {
      return this.$router.push({ name: 'ContactCustomerAll' })
    }
    // get customer
    let res = await this.$store.dispatch('getCustomer', {
      customer_id: this.$route.query.cus_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'ContactCustomerAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'ContactCustomerAll' })
    }
    /**
     *  validation success
     */
    // set form
    this.form.name = this.customer.customer_name
    this.form.gender = this.customer.gender !== null ? this.customer.gender : ''
    this.form.birthdate = this.customer.birthdate !== null ? new Date(this.customer.birthdate) : null
    this.form.address = this.customer.address
    this.form.tax_id = this.customer.tax_id
    for (let i in this.customer.contacts) {
      let item = this.customer.contacts[i]
      if (item.platform == 'email') {
        this.form.email = item.source
      }
      if (item.platform == 'tel') {
        this.form.tel = item.source
      }
      if (item.platform == 'line') {
        this.form.line = item.source
      }
    }
    this.form.note = this.customer.note,
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // set original form
    this.originalForm = this.getObject(this.form)
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.contacts.title'),
      current: {
        app_name: 'contacts',
        app_id: 11,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, [{
      'name': this.$route.query.cus_name,
      'router': {
        'name': 'ContactCustomerEdit',
        'query': {
          cus_id: this.$route.query.cus_id,
          cus_name: this.$route.query.cus_name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 1,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearCustomer'])
  },
  methods: {
    async update (option = {}) {
      if (!this.isValidForm) {
        this.$refs.name.focus()
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return
      }

      this.isSubmitted = true

      let res = await this.$store.dispatch('updateCustomer', this.dataSetUpdate)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.dataSetUpdate.name }),
          color: 'success',
          icon: 'cloud',
        })
        // get products
        await this.$store.dispatch('getCustomer', {
          customer_id: this.customer.customer_id,
        })
        // set original form
        this.originalForm = this.getObject(this.form)
        this.isSubmitted = false
        // set sidebar ui
        sidebarModule.init(this.getObject(require('../sidebar.json')))
        sidebarModule.update(this.sidebar, 1, [{
          'name': this.customer.customer_name,
          'router': {
            'name': 'ContactVendorEdit',
            'query': {
              ven_id: this.customer.customer_id,
              ven_name: this.customer.customer_name,
            },
          },
          'activeClass': 'active',
        }], {
          sidebarAtIdx: 1,
          submenuAtIdx: 2,
        })
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    async del () {
      let data = {
        customer_id: this.customer.customer_id,
      }

      let res = await this.$store.dispatch('deleteCustomer', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.customer.customer_name }),
          color: 'danger',
          icon: 'delete',
        })
        // close modal
        this.closeConfirmdeleteModal()
        // go to ContactCustomerAll page
        return this.$router.push({ name: 'ContactCustomerAll' })
      }
    },
    onKeyupName () {
      this.isValidForm
    },
    clearForm () {
      this.form = this.getObject(this.originalForm)
      this.form.birthdate = new Date(this.originalForm.birthdate)
    },
    openConfirmdeleteModal () {
      // open modal
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/contact/customer/Edit.vue